module.exports = __webpack_public_path__ + "static/media/sliderImage3.53252226.png";